import React from "react";
import { Link } from "react-scroll";

export const Home = () => {
  return (
    <div name="home" className="w-full h-screen bg-navbar">
      {/* container */}
      <div className="max-w-[1000px] mx-auto px-8 flex flex-col justify-center h-full">
        <p className="text-pink-600">Hi, my name is</p>
        <h1 className="text-4xl sm:text-7xl font-bold text-color-white">
          Deepak Kamat
        </h1>
        <h2 className="text-4xl sm:text-7xl font-bold text-color-gray">
          I'm a Front-end Developer
        </h2>
        <p className="text-color-gray py-4 max-w-[700px]">
          I am an enthusiastic front-end developer and an aspiring full stack
          developer having exceptional digital experience. Currently, I'm
          focusing on building responsive front-end web applications.
        </p>
        <div>
          <Link to="work" smooth={true} duration={500}>
            <button className="text-white group border-2 px-6 py-3 my-2 flex items-center hover:bg-pink-600 hover:border-pink-600">
              View Work
              <span className="group-hover:rotate-90 duration-300 ml-3 material-symbols-outlined">
                arrow_forward
              </span>
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};
